import { MouseEventHandler } from "react";

import { ComponentWithAs, IconProps, ListItemProps } from "@chakra-ui/react";

import { AiNavMenuItemSlug } from "./ai";
import { InstantDatasetsNavMenuItemSlug } from "./instantDatasets";
import { ReleaseNavMenuItemSlug } from "./release";

export { aiBottomNavMenuItems, aiTopNavMenuItems } from "./ai";
export { instantDatasetsBottomNavMenuItems, instantDatasetsTopNavMenuItems } from "./instantDatasets";
export { releaseBottomNavMenuItems, releaseTopNavMenuItems } from "./release";

export type { AiNavMenuItemSlug } from "./ai";
export type { InstantDatasetsNavMenuItemSlug } from "./instantDatasets";
export type { ReleaseNavMenuItemSlug } from "./release";

export type NavMenuItem = {
  label: string;
  icon: ComponentWithAs<"svg", IconProps>;
  slug: NavMenuItemSlug;
  pathname: string;
  external?: boolean;
  onClick?: MouseEventHandler | undefined;
} & ListItemProps;

export type NavMenuItemSlug =
  | ReleaseNavMenuItemSlug
  | AiNavMenuItemSlug
  | InstantDatasetsNavMenuItemSlug
  | "admin"
  | "old";
